const SHEET_NAME_MAX_LENGTH = 31;
const INVALID_SHEET_NAME_CHARS = /[\\/?*[\]:]/g;

const truncate = (value, maxLength) => {
  if (value.length <= maxLength) return value;
  const clipped = value.slice(0, maxLength);
  const lastSpaceIndex = clipped.lastIndexOf(" ");
  return (lastSpaceIndex > 0 ? clipped.slice(0, lastSpaceIndex) : clipped).trim();
};

export const sanitizeSheetName = (name, usedNames = []) => {
  let sheetName = String(name ?? "")
    .replace(INVALID_SHEET_NAME_CHARS, "")
    .replace(/\s+/g, " ")
    .trim();

  if (!sheetName) sheetName = "Sheet";

  sheetName = truncate(sheetName, SHEET_NAME_MAX_LENGTH);

  const existing = usedNames.map((existingName) => existingName.toLowerCase());
  if (!existing.includes(sheetName.toLowerCase())) return sheetName;

  let suffix = 2;
  while (true) {
    const suffixText = ` (${suffix})`;
    const candidate = `${truncate(sheetName, SHEET_NAME_MAX_LENGTH - suffixText.length)}${suffixText}`;
    if (!existing.includes(candidate.toLowerCase())) return candidate;
    suffix += 1;
  }
};

